export const clearIconButtonStyles = {
  root: {
    height: 30,
    maxHeight: 30
  },
  icon: {
    fontSize: 12,
    color: 'rgb(163, 162, 160)'
  }
};